import { render, staticRenderFns } from "./CarterMetrics.vue?vue&type=template&id=809b371a&"
import script from "./CarterMetrics.vue?vue&type=script&lang=ts&"
export * from "./CarterMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports